import { createSelector } from '@reduxjs/toolkit';

import { LOCATION } from '../../settings';

import { getFilterLocation } from './getFilterLocation';

export const checkSpbRegion = createSelector(getFilterLocation, location => location === LOCATION.SPB_AND_AREA.ID);
